<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header" *ngIf="role">
    <div class="card-title">
      <h3 class="card-label" translate>
        {{ getTitle() }}
        <span class="card-label">{{ roleTitle ? roleTitle : '' }} Agreement</span>
      </h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body" *ngIf="role">
      <!-- <div class="card-body-progress">
                    <mat-spinner [diameter]="20"></mat-spinner>
                </div> -->
      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>

      <!--<kt-alert *ngIf="hasSubmissionErrors && !hasFormErrors" type="warn" [duration]="30000" [showCloseButton]="true" (closeAl)="onAlertClose($event)">
                <ul>
                    <li *ngFor="let msg of submissionErrorObj">{{msg.message | translate}}</li>
                </ul>
			</kt-alert>-->

      <div class="mb-2">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label translate="ROLES.FORM.TITLE">Title</mat-label>
          <input matInput [(ngModel)]="template.title" required />
          <mat-error
            ><span translate="ROLES.FORM.TITLE_REQUIRED">Title is required</span></mat-error
          >
        </mat-form-field>
      </div>

      <div class="separator separator-dashed my-6"></div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            mat-dialog-close
            cdkFocusInitial
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            [disabled]="!isTitleValid() || viewLoading"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
